'use strict';

/* Libs */
import 'paypal-checkout';
import 'angularjs-stripe-elements'

/* Views */
import PaymentList from './list/payment-list.component';
import PaymentPlanList from './plan-list/payment-plan-list.component';
import PaymentPlanEdit from './plan-edit/payment-plan-edit.component';
import BankingAccountList from '../user/banking-accounts/list/banking-accounts-list.component';
import BankingAccountEdit from '../user/banking-accounts/edit/banking-accounts-edit.component';

/* Components */
import PaymentComponent from '../../components/payment/payment.component';
import AccountVerificationComponent from '../../components/banking-account-verification/banking-account-verification.component';

/* Services */
import PaymentService from '../../services/payment/payment.service';
import BankingAccountsService from '../../services/banking-accounts/banking-accounts.service';
import RecurringPaymentsService from '../../services/recurring-payments/recurring-payments.service';

export default angular.module('conduuApp.payment', ['paypal-button', 'angularjs-stripe-elements',
  PaymentList, PaymentPlanList, PaymentPlanEdit, PaymentComponent, PaymentService,
  BankingAccountsService, BankingAccountList, BankingAccountEdit,
  AccountVerificationComponent, RecurringPaymentsService])
  .name;



// WEBPACK FOOTER //
// ./client/app/payment/index.js